<app-validation-container [messages]="validationMessages"></app-validation-container>

<div
  #datatableContainer
  [attr.data-automation-id]="dataAutomationId"
  [hidden]="validationMessages.length > 0"
>
  <div class="datatable-actions-container">
    <div
      class="datatable-filter-container"
      [ngClass]="{ 'datatable-filter-container--bottom-border': true }"
    >
      <app-datatable-filter
        #datatableFilters
        *ngIf="!disableFiltering"
        [columns]="columns"
        [defaultFilter]="defaultFilter"
        [resetAttributesAfterApply]="resetAttributesAfterApply"
        [warningMessage]="warningMessage"
        [filterByAttributes]="filterByAttributes"
        (filtersChanged)="filtersChanged($event)"
      ></app-datatable-filter>
    </div>

    <div class="d-flex align-items-center" [ngClass]="{ 'py-2': multiSelect || showExportToCsv }">
      <div *ngIf="multiSelect" class="datatable-multi-select d-flex align-items-center">
        <div class="mr-2">
          <mat-checkbox
            #selectAllCheckbox
            [checked]="false"
            class="ml-2"
            (change)="selectedAll(selectAllCheckbox.checked)"
          >
            Select All
          </mat-checkbox>
        </div>
      </div>
      <div class="fill-remaining-space"></div>
      <div *ngIf="this.showExportToCsv">
        <button
          mat-button
          color="primary"
          class="mat-filter-button ml-2 mr-2"
          (click)="exportData()"
          aria-label="Export To CSV"
          [disabled]="!rows?.length"
        >
          <mat-icon>download</mat-icon>
          Export
        </button>
      </div>
    </div>
    <div *ngIf="multiSelect" class="ml-2 mb-2 d-flex align-items-center">
      <div *ngIf="bulkEditActionTmpl && selection?.length">
        <ng-template
          *ngTemplateOutlet="bulkEditActionTmpl; context: { selected: selection }"
        ></ng-template>
      </div>
    </div>
  </div>

  <ngx-datatable
    #ngxDatatable
    [rows]="rows"
    [columns]="dtColumns"
    [columnMode]="columnMode"
    [headerHeight]="headerHeight"
    [footerHeight]="!tableEmpty() ? footerHeight : 0"
    [rowHeight]="rowHeight"
    [scrollbarV]="scrollV"
    [scrollbarH]="scrollH"
    [externalPaging]="true"
    [externalSorting]="true"
    [count]="filteredCount"
    [messages]="messages"
    [offset]="pageOffset"
    [limit]="pageSize"
    [virtualization]="false"
    [selected]="selection"
    [selectionType]="multiSelect ? 'multiClick' : 'single'"
    [rowClass]="rowClass"
    (sort)="sorted($event)"
    (select)="selectedRow($event)"
  >
    <!-- Row Detail Template -->
    <ngx-datatable-row-detail [rowHeight]="rowDetailHeight">
      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
        <ng-template *ngTemplateOutlet="rowDetailTmpl; context: { $implicit: row }"></ng-template>
      </ng-template>
    </ngx-datatable-row-detail>

    <ngx-datatable-footer *ngIf="!tableEmpty()">
      <ng-template ngx-datatable-footer-template>
        <div class="dt-footer d-flex align-items-center w-100">
          <div class="footer-pager pager d-flex align-items-center">
            <span class="pager-page-text-wrapper">Page {{ currentPage }} of {{ totalPages }}</span>
            <button
              class="paging-chevrons"
              [tabindex]="firstPageClass().disabled ? '-1' : '0'"
              [ngClass]="firstPageClass()"
              (click)="firstPage()"
            >
              <mat-icon>first_page</mat-icon>
              <span class="sr-only">First page</span>
            </button>
            <button
              class="paging-chevrons"
              [tabindex]="prevPageClass().disabled ? '-1' : '0'"
              [ngClass]="prevPageClass()"
              (click)="prevPage()"
            >
              <mat-icon>chevron_left</mat-icon>
              <span class="sr-only">Previous page</span>
            </button>
            <button
              *ngFor="let page of pages; last as last"
              class="paging-numbers list-inline-item text-center"
              [ngClass]="pageClass(page, last)"
              (click)="gotoPage(page)"
            >
              <span class="sr-only">Jump to Page</span>
              {{ page }}
            </button>
            <button
              class="paging-chevrons"
              [tabindex]="nextPageClass().disabled ? '-1' : '0'"
              [ngClass]="nextPageClass()"
              (click)="nextPage()"
            >
              <mat-icon>chevron_right</mat-icon>
              <span class="sr-only">Next page</span>
            </button>
            <button
              class="paging-chevrons"
              [tabindex]="lastPageClass().disabled ? '-1' : '0'"
              [ngClass]="lastPageClass()"
              (click)="lastPage()"
            >
              <mat-icon>last_page</mat-icon>
              <span class="sr-only">Last page</span>
            </button>
          </div>
          <div class="footer-counter d-flex align-items-center">
            Showing {{ beginningCount }}-{{ endCount }} of {{ filteredCount | number }}
          </div>
          <div class="footer-sizer d-flex align-items-center">
            <mat-form-field class="pager-size-picker">
              <mat-select [(value)]="pageSize" (selectionChange)="changedPageSize()">
                <mat-option [value]="10">10</mat-option>
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
              </mat-select>
              <mat-label class="pager-size-text-wrapper">Items per page</mat-label>
            </mat-form-field>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>

  <ng-template #actionHeaderTmpl let-column="column" let-sort="sortFn">
    <div class="d-flex align-items-center justify-content-center"></div>
  </ng-template>

  <ng-template #genericHeaderTmpl let-column="column" let-sort="sortFn">
    <button
      mat-button
      class="d-flex align-items-center cursor-pointer"
      color="primary"
      (click)="sort()"
      [attr.aria-label]="
        'Sort rows by ' +
        column.name +
        (columnsByPropTitle[column.prop + '|' + (column.name || '')].titleToolTip
          ? ', ' + columnsByPropTitle[column.prop + '|' + (column.name || '')].titleToolTip
          : '')
      "
      [attr.data-column-label]="column.name"
    >
      <span class="column-name">
        {{ column.name }}
        <mat-icon
          *ngIf="columnsByPropTitle[column.prop + '|' + (column.name || '')].titleToolTip"
          class="tooltip-icon-height"
          [attr.aria-label]="
            'Tooltip: ' + columnsByPropTitle[column.prop + '|' + (column.name || '')].titleToolTip
          "
          [matTooltip]="columnsByPropTitle[column.prop + '|' + (column.name || '')].titleToolTip"
          [matTooltipPosition]="'above'"
          matTooltipClass="mat-tooltip-centered"
        >
          help
        </mat-icon>
      </span>

      <!-- Ascending == A-Z; 1-100; Oldest-Newest; arrow facing up -->
      <!-- Descending == Z-A; 100-1; Newest-Oldest; arrow facing down -->
      <div
        *ngIf="externalSortStyle && !disableSorting && column.sortable"
        style="display: inline-block"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="3 3 18 18" class="sort-icon">
          <path
            d="M 14 19 l 7 -7 l -7 -7 V 19 L 14 19 z"
            class="sort-icon-path"
            [ngClass]="{ 'sort-active': currentSort[column.prop] === false }"
          />
          <path
            d="M 10 19 V 5 l -7 7 L 10 19 z"
            class="sort-icon-path"
            [ngClass]="{ 'sort-active': currentSort[column.prop] === true }"
          />
        </svg>
      </div>
      <div
        *ngIf="!externalSortStyle && !disableSorting && column.sortable"
        style="display: inline-block"
      >
        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" class="sort-icon--internal">
          <path
            d="M5.83 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
            class="sort-icon-path"
            [ngClass]="{ 'sort-active': currentSort[column.prop] === false }"
          />
          <path
            d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83z"
            class="sort-icon-path"
            [ngClass]="{ 'sort-active': currentSort[column.prop] === true }"
          />
        </svg>
      </div>
    </button>
  </ng-template>

  <ng-template #detailToggleTmpl let-row="row" let-expanded="expanded">
    <button
      *ngIf="expanded && (row | rowDetailVisible: rowDetailVisiblePipe)"
      mat-button
      class="mat-large-icon mat-simple-button"
      color="primary"
      (click)="toggleDetail(row, $event)"
    >
      <mat-icon title="Collapse row" class="accordion-icon">expand_less</mat-icon>
      <span class="sr-only">Collapse row</span>
    </button>

    <button
      *ngIf="!expanded && (row | rowDetailVisible: rowDetailVisiblePipe)"
      mat-button
      title="Expand row"
      class="mat-simple-button mat-large-icon"
      color="primary"
      (click)="toggleDetail(row, $event)"
    >
      <mat-icon>chevron_right</mat-icon>
      <span class="sr-only">Expand row</span>
    </button>
  </ng-template>

  <ng-template #easternDateTemplate let-value="value">
    <span class="datatable-numeric-cell">
      {{ value | easternMoment | dateFormat }}
    </span>
  </ng-template>

  <ng-template #easternDateTimeTemplate let-value="value">
    <span class="datatable-numeric-cell">
      {{ value | easternMoment | dateTimeFormat }}
    </span>
  </ng-template>

  <ng-template #utcDateTemplate let-value="value">
    <span class="datatable-numeric-cell">
      {{ value | utcMoment | dateFormat }}
    </span>
  </ng-template>

  <ng-template #utcDateTimeTemplate let-value="value">
    <span class="datatable-numeric-cell">
      {{ value | utcMoment | dateTimeFormat }}
    </span>
  </ng-template>

  <ng-template #utcDateTimeHMSTemplate let-value="value">
    <span class="datatable-numeric-cell">
      {{ value | utcMoment | dateTimeFormat: 'MM/DD/YYYY h:mm:ss A' }}
    </span>
  </ng-template>

  <ng-template #easternDateTimeHMSTemplate let-value="value">
    <span class="datatable-numeric-cell">
      {{ value | easternMoment | dateTimeFormat: 'MM/DD/YYYY HH:mm:ss' }}
    </span>
  </ng-template>

  <ng-template #currencyTemplate let-value="value">
    <span class="datatable-numeric-cell">
      {{ value | currency }}
    </span>
  </ng-template>

  <ng-template #yesNoTemplate let-value="value">
    {{ value | yesNoFormatter }}
  </ng-template>

  <ng-template #feinTemplate let-value="value">
    {{ value | feinFormatter }}
  </ng-template>

  <ng-template #phoneNumberTemplate let-value="value">
    {{ value.length == 10 ? (value | usPhoneNumberFormatter) : value }}
  </ng-template>

  <ng-template #entityTemplate let-row="row" let-value="value">
    <a
      *ngIf="value != null && value !== ''"
      routerLink="[AppUrls.detailsForSystemType(row.entityId, row.entityTypeId)]"
    >
      {{ value }}
    </a>
  </ng-template>

  <ng-template #transactionTemplate let-row="row" let-value="value">
    <a
      *ngIf="value != null && value !== ''"
      routerLink="[AppUrls.detailsForTransaction(row.transactionId, row.transactionTypeId)]"
    >
      {{ value }}
    </a>
  </ng-template>

  <ng-template #checkboxTemplate let-isSelected="isSelected" let-row="row">
    <mat-checkbox
      *ngIf="multiSelect"
      #checkbox
      class="mat-checkbox--limited-focus my-1 mr-1 ml-0"
      (click)="$event.stopPropagation()"
      [checked]="isSelected"
      (change)="onCheckBoxChange(row)"
    >
      <span class="sr-only">Select Row</span>
    </mat-checkbox>
  </ng-template>

  <ng-template #priorityTagTemplate let-row="row" let-value="value">
    <span class="priority-column" *ngIf="value">Yes</span>
  </ng-template>

  <ng-template
    #activeInactiveTemplate
    let-row="row"
    let-value="value"
    let-valueLowercase="value.trim().toLowerCase()"
  >
    <span *ngIf="value === true">Active</span>
    <span *ngIf="value === false">Inactive</span>
    <span *ngIf="value !== false && value !== true">{{ value }}</span>
  </ng-template>

  <ng-template #caseNumberTemplate let-value="value">
    {{ value }}
  </ng-template>

  <ng-template #formNameTemplate let-value="value">
    <span [title]="value">
      {{ value }}
    </span>
  </ng-template>

  <ng-template #defaultTemplate let-value="value">
    {{ value }}
  </ng-template>
</div>
